import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 32"
}, c = /* @__PURE__ */ l("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.465 16c0-8.837 7.157-16 15.985-16s15.984 7.163 15.984 16-7.156 16-15.984 16S.465 24.837.465 16m15.506-2.995.034.554-.56-.068c-2.034-.26-3.812-1.141-5.321-2.621l-.738-.735-.19.543c-.403 1.208-.146 2.485.693 3.344.447.474.346.542-.425.26-.268-.09-.503-.158-.526-.124-.078.079.19 1.107.403 1.514.29.564.883 1.118 1.532 1.446l.548.26-.649.01c-.626 0-.649.012-.581.25.223.734 1.106 1.513 2.09 1.852l.694.238-.604.361a6.3 6.3 0 0 1-2.997.836c-.503.012-.916.057-.916.09 0 .114 1.364.747 2.158.995 2.381.734 5.21.418 7.334-.836 1.51-.893 3.019-2.666 3.723-4.384.38-.915.76-2.587.76-3.39 0-.52.034-.587.66-1.209.37-.361.716-.757.783-.87.112-.214.1-.214-.47-.022-.95.339-1.084.294-.615-.215.347-.361.76-1.017.76-1.209 0-.034-.167.023-.357.125-.201.113-.649.282-.984.384l-.604.192-.548-.373c-.302-.203-.726-.43-.95-.497-.57-.158-1.442-.136-1.957.045-1.397.508-2.28 1.82-2.18 3.254",
  "clip-rule": "evenodd"
}, null, -1), n = [
  c
];
function r(d, i) {
  return e(), t("svg", o, [...n]);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
